(function(a, b, c) {
    if (typeof module !== "undefined" && module.exports) {
        module.exports = c()
    } else if (typeof define === "function" && define.amd) {
        define(c)
    } else {
        b[a] = c()
    }
})("h337square", this, function() {
    var a = {
        defaultRadius: 40,
        defaultRenderer: "canvas2d",
        defaultGradient: {.25: "rgb(0,0,255)", .55: "rgb(0,255,0)", .85: "yellow",
                1: "rgb(255,0,0)"
        },
        defaultMaxOpacity: 1,
        defaultMinOpacity: 0,
        defaultBlur: .85,
        defaultXField: "x",
        defaultYField: "y",
        defaultValueField: "value",
        plugins: {}
    };
    var b = function h() {
        var b = function d(a) {
            this._coordinator = {};
            this._data = [];
            this._radi = [];
            this._min = 0;
            this._max = 1;
            this._xField = a["xField"] || a.defaultXField;
            this._yField = a["yField"] || a.defaultYField;
            this._valueField = a["valueField"] || a.defaultValueField;
            if (a["radius"]) {
                this._cfgRadius = a["radius"]
            }
            this._c_width = a["c_width"];
            this._c_height = a["c_height"];
        };
        var c = a.defaultRadius;
        b.prototype = {
            _organiseData: function(a, b) {
                var d = a[this._xField];
                var e = a[this._yField];
                var f = this._radi;
                var g = this._data;
                var h = this._max;
                var i = this._min;
                var j = a[this._valueField] || 1;
                var k = a.radius || this._cfgRadius || c;
                if (!g[d]) {
                    g[d] = [];
                    f[d] = []
                }
                if (!g[d][e]) {
                    g[d][e] = j;
                    f[d][e] = k
                } else {
                    g[d][e] += j
                }
                if (g[d][e] > h) {
                    if (!b) {
                        this._max = g[d][e]
                    } else {
                        this.setDataMax(g[d][e])
                    }
                    return false
                } else {
                    return {
                        x: d,
                        y: e,
                        value: j,
                        radius: k,
                        c_width: this._c_width,
                        c_height: this._c_height,
                        min: i,
                        max: h
                    }
                }
            },
            _unOrganizeData: function() {
                var a = [];
                var b = this._data;
                var c = this._radi;
                for (var d in b) {
                    for (var e in b[d]) {
                        a.push({
                            x: d,
                            y: e,
                            radius: c[d][e],
                            value: b[d][e],
                            c_width: this._c_width,
                            c_height: this._c_height,
                        })
                    }
                }
                return {
                    min: this._min,
                    max: this._max,
                    data: a
                }
            },
            _onExtremaChange: function() {
                this._coordinator.emit("extremachange", {
                    min: this._min,
                    max: this._max
                })
            },
            addData: function() {
                if (arguments[0].length > 0) {
                    var a = arguments[0];
                    var b = a.length;
                    while (b--) {
                        this.addData.call(this, a[b])
                    }
                } else {
                    var c = this._organiseData(arguments[0], true);
                    if (c) {
                        this._coordinator.emit("renderpartial", {
                            min: this._min,
                            max: this._max,
                            data: [c]
                        })
                    }
                }
                return this
            },
            setData: function(a) {
                var b = a.data;
                var c = b.length;
                this._data = [];
                this._radi = [];
                for (var d = 0; d < c; d++) {
                    this._organiseData(b[d], false)
                }
                this._max = a.max;
                this._min = a.min || 0;
                this._onExtremaChange();
                this._coordinator.emit("renderall", this._getInternalData());
                return this
            },
            removeData: function() {},
            setDataMax: function(a) {
                this._max = a;
                this._onExtremaChange();
                this._coordinator.emit("renderall", this._getInternalData());
                return this
            },
            setDataMin: function(a) {
                this._min = a;
                this._onExtremaChange();
                this._coordinator.emit("renderall", this._getInternalData());
                return this
            },
            setCoordinator: function(a) {
                this._coordinator = a
            },
            _getInternalData: function() {
                return {
                    max: this._max,
                    min: this._min,
                    data: this._data,
                    radi: this._radi,
                    c_width: this._c_width,
                    c_height: this._c_height,
                }
            },
            getData: function() {
                return this._unOrganizeData()
            }
        };
        return b
    }();
    var c = function i() {
        var a = function(a) {
            var b = a.gradient || a.defaultGradient;
            var c = document.createElement("canvas");
            var d = c.getContext("2d");
            c.width = 256;
            c.height = 1;
            var e = d.createLinearGradient(0, 0, 256, 1);
            for (var f in b) {
                e.addColorStop(f, b[f])
            }
            d.fillStyle = e;
            d.fillRect(0, 0, 256, 1);
            return d.getImageData(0, 0, 256, 1).data
        };
        var b = function(w, h, b) {
            var c = document.createElement("canvas");
            var d = c.getContext("2d");
            // var e = a;
            // var f = a;
            // c.width = c.height = a * 2;

            c.width = w;
            c.height = h;
            if (b == 1) {
                d.beginPath();
                //d.arc(e, f, a, 0, 2 * Math.PI, false);
                d.fillStyle = "rgba(0,0,0,1)";
                d.fill()
            } else {
                
                //中央からグラデーションする場合
                var g = d.createLinearGradient(0, 0, 0, h);

                // g.addColorStop(0, "rgba(0,0,0,0)");
                // g.addColorStop(0.25, "rgba(0,0,0,0.5)");
                // g.addColorStop(0.5, "rgba(0,0,0,1)");
                // g.addColorStop(0.75, "rgba(0,0,0,0.5)");
                // g.addColorStop(1, "rgba(0,0,0,0)");

                g.addColorStop(0,    "rgba(0,0,0,0)");
                g.addColorStop(0.20, "rgba(0,0,0,0.5)");
                g.addColorStop(0.40, "rgba(0,0,0,1)");
                g.addColorStop(0.60, "rgba(0,0,0,1)");
                g.addColorStop(0.80, "rgba(0,0,0,0.5)");
                g.addColorStop(1,    "rgba(0,0,0,0)");

                d.fillStyle = g;
                d.globalAlpha = 0.75;
                d.fillRect(0, 0, w, h);
            }
            return c
        };
        var c = function(a) {
            var c_width = a.c_width;
            var c_height = a.c_height;

            var b = [];
            var c = a.min;
            var d = a.max;
            var e = a.radi;
            var a = a.data;
            var f = Object.keys(a);
            var g = f.length;
            while (g--) {
                var h = f[g];
                var i = Object.keys(a[h]);
                var j = i.length;
                while (j--) {
                    var k = i[j];
                    var l = a[h][k];
                    var m = e[h][k];
                    b.push({
                        x: h,
                        y: k,
                        value: l,
                        radius: m,
                        c_width: c_width,
                        c_height: c_height
                    })
                }
            }
            
            var k = {
                min: c,
                max: d,
                data: b,
                c_width: c_width,
                c_height: c_height
            }
            return k;
        };

        function d(b) {
            var c = b.container;
            var d = this.shadowCanvas = document.createElement("canvas");
            var e = this.canvas = b.canvas || document.createElement("canvas");
            var f = this._renderBoundaries = [1e4, 1e4, 0, 0];
            var g = getComputedStyle(b.container) || {};
            e.className = "heatmap-canvas";
            this._width = e.width = d.width = b.width || +g.width.replace(/px/, "");
            this._height = e.height = d.height = b.height || +g.height.replace(/px/, "");
            // this._height = e.height = d.height = b.height || +b.container.scrollHeight;
            this.shadowCtx = d.getContext("2d");
            this.ctx = e.getContext("2d");
            e.style.cssText = d.style.cssText = "position:absolute;left:0;top:0;";
            c.style.position = "relative";
            c.appendChild(e);
            // requestAnimationFrame(() => {
			// 	e.classList.add('is_show');
			// });
            
            this._palette = a(b);
            this._templates = {};
            this._setStyles(b)
        }
        d.prototype = {
            renderPartial: function(a) {
                if (a.data.length > 0) {
                    this._drawAlpha(a);
                    this._colorize()
                }
            },
            renderAll: function(a) {
                this._clear();
                if (a.data.length > 0) {
                    this._drawAlpha(c(a));
                    // this._drawAlpha(a);
                    this._colorize()
                }
            },
            _updateGradient: function(b) {
                this._palette = a(b)
            },
            updateConfig: function(a) {
                if (a["gradient"]) {
                    this._updateGradient(a)
                }
                this._setStyles(a)
            },
            setDimensions: function(a, b) {
                this._width = a;
                this._height = b;
                this.canvas.width = this.shadowCanvas.width = a;
                this.canvas.height = this.shadowCanvas.height = b
            },
            _clear: function() {
                this.shadowCtx.clearRect(0, 0, this._width, this._height);
                this.ctx.clearRect(0, 0, this._width, this._height)
            },
            _setStyles: function(a) {
                this._offsetY = a.offsetY || 0;
                this._blur = a.blur == 0 ? 0 : a.blur || a.defaultBlur;
                if (a.backgroundColor) {
                    this.canvas.style.backgroundColor = a.backgroundColor
                }
                this._width = this.canvas.width = this.shadowCanvas.width = a.width ||
                    this._width;
                this._height = this.canvas.height = this.shadowCanvas.height = a.height ||
                    this._height;
                this._opacity = (a.opacity || 0) * 255;
                this._maxOpacity = (a.maxOpacity || a.defaultMaxOpacity) * 255;
                this._minOpacity = (a.minOpacity || a.defaultMinOpacity) * 255;
                this._useGradientOpacity = !!a.useGradientOpacity
            },
            _drawAlpha: function(a) {
                var c_width = a.c_width;
                var c_height = a.c_height;
                var c = this._min = a.min;
                var d = this._max = a.max;
                var data = a.data || [];
                var e = data.length;
                var f = 1 - this._blur;

                // --- 1) まずレンダリング境界を確定 ---
                var minX = 1e9, minY = 1e9, maxX = 0, maxY = 0;

                // テンプレ（カーネル）を用意（既存キャッシュ流用）
                var tplKey = c_width + '/' + c_height;
                var tplCanvas;
                if (!this._templates[tplKey]) {
                    this._templates[tplKey] = tplCanvas = b(c_width, c_height, f);
                } else {
                    tplCanvas = this._templates[tplKey];
                }

                // data内の座標を走査して境界計算
                for (var idx = 0; idx < e; idx++) {
                    var g = data[idx];
                    var h = g.x;
                    var i = g.y - this._offsetY;

                    var l = h - c_width / 2;
                    var m = i - c_height / 2;

                    if (l < minX) minX = l;
                    if (m < minY) minY = m;
                    if (l + c_width > maxX) maxX = l + c_width;
                    if (m + c_height > maxY) maxY = m + c_height;
                }

                // clamp & int化
                minX = Math.max(0, Math.floor(minX));
                minY = Math.max(0, Math.floor(minY));
                maxX = Math.min(this._width, Math.ceil(maxX));
                maxY = Math.min(this._height, Math.ceil(maxY));

                var regionW = Math.max(0, maxX - minX);
                var regionH = Math.max(0, maxY - minY);

                // 境界が無ければ終了
                if (regionW <= 0 || regionH <= 0) {
                    this._renderBoundaries = [1e3, 1e3, 0, 0];
                    return;
                }

                // --- 2) テンプレ alpha をキャッシュ（1回だけ） ---
                // alpha配列（w*h）だけ持つ
                if (!this._templatesAlpha) this._templatesAlpha = {};
                if (!this._templatesAlpha[tplKey]) {
                    var tImg = tplCanvas.getContext("2d").getImageData(0, 0, c_width, c_height).data;
                    var tA = new Uint8ClampedArray(c_width * c_height);
                    var maxA = 0;

                    for (var ti = 0, pj = 0; ti < tImg.length; ti += 4, pj++) {
                        var a8 = tImg[ti + 3]; // alpha(0..255)
                        tA[pj] = a8;
                        if (a8 > maxA) maxA = a8;
                    }

                    // maxA が0は保険で1
                    this._templatesAlpha[tplKey] = { a: tA, max: maxA || 1 };
                }

                var tplAlpha = this._templatesAlpha[tplKey].a;
                var tplAlphaMax = this._templatesAlpha[tplKey].max;

                // --- 3) region の alpha を「max合成」で作る ---
                // regionAlpha[y*W + x] に 0..255 を格納（max更新）
                var need = regionW * regionH;
                if (!this._regionAlphaBuf || this._regionAlphaBuf.length < need) {
                    this._regionAlphaBuf = new Uint8ClampedArray(need);
                } else {
                    this._regionAlphaBuf.fill(0, 0, need);
                }
                var regionAlpha = this._regionAlphaBuf;

                for (var idx2 = 0; idx2 < e; idx2++) {
                    var g2 = data[idx2];
                    var h2 = g2.x;
                    var i2 = g2.y - this._offsetY;

                    var k = Math.min(g2.value, d);
                    var p = (k - c) / (d - c);
                    if (!Number.isFinite(p) || p <= 0) continue;

                    // 元実装の「最低0.01」は維持
                    if (p < 0.01) p = 0.01;

                    var l2 = Math.floor(h2 - c_width / 2);
                    var m2 = Math.floor(i2 - c_height / 2);

                    // region内の相対座標
                    var rx = l2 - minX;
                    var ry = m2 - minY;

                    // はみ出しclip（基本minX/minYで切ってるけど保険）
                    var startX = 0;
                    var startY = 0;
                    var endX = c_width;
                    var endY = c_height;

                    if (rx < 0) startX = -rx;
                    if (ry < 0) startY = -ry;
                    if (rx + c_width > regionW) endX = regionW - rx;
                    if (ry + c_height > regionH) endY = regionH - ry;

                    if (startX >= endX || startY >= endY) continue;

                    for (var yy = startY; yy < endY; yy++) {
                        var dstRow = (ry + yy) * regionW + rx;
                        var srcRow = yy * c_width;

                        for (var xx = startX; xx < endX; xx++) {
                            var srcA = tplAlpha[srcRow + xx];
                            if (srcA === 0) continue;

                            var v = (srcA * p * 255 / tplAlphaMax) | 0;
                            if (v > 255) v = 255;
                            var di = dstRow + xx;

                            if (v > regionAlpha[di]) {
                                regionAlpha[di] = v;
                            }
                        }
                    }
                }

                // --- 4) regionAlpha を shadowCtx に書き戻す（alphaだけ） ---
                if (!this._outImgBuf || this._outImgBuf.width !== regionW || this._outImgBuf.height !== regionH) {
                    this._outImgBuf = this.shadowCtx.createImageData(regionW, regionH);
                }
                var out = this._outImgBuf;
                var outData = out.data;

                for (var pi2 = 0, di2 = 0; pi2 < need; pi2++, di2 += 4) {
                    outData[di2] = 0;
                    outData[di2 + 1] = 0;
                    outData[di2 + 2] = 0;
                    outData[di2 + 3] = regionAlpha[pi2];
                }

                this.shadowCtx.putImageData(out, minX, minY);

                // 境界更新（_colorize がこの範囲だけ取る）
                this._renderBoundaries[0] = minX;
                this._renderBoundaries[1] = minY;
                this._renderBoundaries[2] = maxX;
                this._renderBoundaries[3] = maxY;
            },

            _colorize: function() {
                var a = this._renderBoundaries[0];
                var b = this._renderBoundaries[1];
                var c = this._renderBoundaries[2] - a;
                var d = this._renderBoundaries[3] - b;
                var e = this._width;
                var f = this._height;
                var g = this._opacity;
                var h = this._maxOpacity;
                var i = this._minOpacity;
                var j = this._useGradientOpacity;
                if (a < 0) {
                    a = 0
                }
                if (b < 0) {
                    b = 0
                }
                if (a + c > e) {
                    c = e - a
                }
                if (b + d > f) {
                    d = f - b
                }
                var k = this.shadowCtx.getImageData(a, b, c, d);
                var l = k.data;
                var m = l.length;
                var n = this._palette;
                for (var o = 3; o < m; o += 4) {
                    var p = l[o];
                    var q = p * 4;
                    if (!q) {
                        continue
                    }
                    var r;
                    if (g > 0) {
                        r = g
                    } else {
                        if (p < h) {
                            if (p < i) {
                                r = i
                            } else {
                                r = p
                            }
                        } else {
                            r = h
                        }
                    }
                    l[o - 3] = n[q];
                    l[o - 2] = n[q + 1];
                    l[o - 1] = n[q + 2];
                    l[o] = j ? n[q + 3] : r
                }
                // k.data = l;
                // this.ctx.putImageData(k, a, b);
                var img = new ImageData(l, c, d);
                this.ctx.putImageData(img, a, b);
                this._renderBoundaries = [1e3, 1e3, 0, 0]
            },
            getValueAt: function(a) {
                var b;
                var c = this.shadowCtx;
                var d = c.getImageData(a.x, a.y, 1, 1);
                var e = d.data[3];
                var f = this._max;
                var g = this._min;
                b = Math.abs(f - g) * (e / 255) >> 0;
                return b
            },
            getDataURL: function() {
                return this.canvas.toDataURL()
            }
        };
        return d
    }();
    var d = function j() {
        var b = false;
        if (a["defaultRenderer"] === "canvas2d") {
            b = c
        }
        return b
    }();
    var e = {
        merge: function() {
            var a = {};
            var b = arguments.length;
            for (var c = 0; c < b; c++) {
                var d = arguments[c];
                for (var e in d) {
                    a[e] = d[e]
                }
            }
            return a
        }
    };
    var f = function k() {
        var c = function h() {
            function a() {
                this.cStore = {}
            }
            a.prototype = {
                on: function(a, b, c) {
                    var d = this.cStore;
                    if (!d[a]) {
                        d[a] = []
                    }
                    d[a].push(function(a) {
                        return b.call(c, a)
                    })
                },
                emit: function(a, b) {
                    var c = this.cStore;
                    if (c[a]) {
                        var d = c[a].length;
                        for (var e = 0; e < d; e++) {
                            var f = c[a][e];
                            f(b)
                        }
                    }
                }
            };
            return a
        }();
        var f = function(a) {
            var b = a._renderer;
            var c = a._coordinator;
            var d = a._store;
            c.on("renderpartial", b.renderPartial, b);
            c.on("renderall", b.renderAll, b);
            c.on("extremachange", function(b) {
                a._config.onExtremaChange && a._config.onExtremaChange({
                    min: b.min,
                    max: b.max,
                    gradient: a._config["gradient"] || a._config["defaultGradient"]
                })
            });
            d.setCoordinator(c)
        };

        function g() {
            var g = this._config = e.merge(a, arguments[0] || {});
            this._coordinator = new c;
            if (g["plugin"]) {
                var h = g["plugin"];
                if (!a.plugins[h]) {
                    throw new Error("Plugin '" + h +
                        "' not found. Maybe it was not registered.")
                } else {
                    var i = a.plugins[h];
                    this._renderer = new i.renderer(g);
                    this._store = new i.store(g)
                }
            } else {
                this._renderer = new d(g);
                this._store = new b(g)
            }
            f(this)
        }
        g.prototype = {
            addData: function() {
                this._store.addData.apply(this._store, arguments);
                return this
            },
            removeData: function() {
                this._store.removeData && this._store.removeData.apply(this._store,
                    arguments);
                return this
            },
            setData: function() {
                this._store.setData.apply(this._store, arguments);
                return this
            },
            setDataMax: function() {
                this._store.setDataMax.apply(this._store, arguments);
                return this
            },
            setDataMin: function() {
                this._store.setDataMin.apply(this._store, arguments);
                return this
            },
            configure: function(a) {
                this._config = e.merge(this._config, a);
                this._renderer.updateConfig(this._config);
                this._coordinator.emit("renderall", this._store._getInternalData());
                return this
            },
            repaint: function() {
                this._coordinator.emit("renderall", this._store._getInternalData());
                return this
            },
            getData: function() {
                return this._store.getData()
            },
            getDataURL: function() {
                return this._renderer.getDataURL()
            },
            getValueAt: function(a) {
                if (this._store.getValueAt) {
                    return this._store.getValueAt(a)
                } else if (this._renderer.getValueAt) {
                    return this._renderer.getValueAt(a)
                } else {
                    return null
                }
            }
        };
        return g
    }();
    var g = {
        create: function(a) {
            return new f(a)
        },
        register: function(b, c) {
            a.plugins[b] = c
        }
    };
    return g
});
